import { jsx as _jsx } from "react/jsx-runtime";
// import components
import ListItemButton from "@mui/material/ListItemButton";
import { NavigationRailItem, NavigationRailSubItem } from "./ListItemButton.components.js";
const ComponentMap = {
    navigationRail: NavigationRailItem,
    navigationRailSub: NavigationRailSubItem,
    default: ListItemButton,
};
export const ListItemButtonAtomComponent = ({ type = "default", ...props }) => {
    const Component = ComponentMap[type];
    return _jsx(Component, { "data-testid": "ListItemButton", ...props });
};
export default ListItemButtonAtomComponent;
